import { AccountPosition } from '../../../accounts/positions/type';
import { PersonAccounts } from '../../../persons/accounts/type';

export const currencyIsEur = (currency: |
AccountPosition['C_CURRENCY.CODE'] |
AccountPosition['C_CURRENCY_T_ACC.CODE'] |
PersonAccounts['C_CURRENCY_T_ACC.CODE']) => currency === 'EUR';
